// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53d44d49","239":"68a51164","455":"ffe3c0b8"}[chunkId] + ".chunk.js";
};